import React from "react";
import { X, CheckCircle, AlertTriangle, Info } from "lucide-react";

const Modal = ({
  isOpen,
  onClose,
  title,
  message,
  onConfirm,
  type = "alert",
}) => {
  if (!isOpen) return null;

  const getIcon = () => {
    if (title.toLowerCase().includes("sucesso"))
      return <CheckCircle className="text-green-500 h-8 w-8 mr-3" />;
    if (
      title.toLowerCase().includes("erro") ||
      title.toLowerCase().includes("perigo")
    )
      return <AlertTriangle className="text-red-500 h-8 w-8 mr-3" />;
    if (title.toLowerCase().includes("confirmar"))
      return <AlertTriangle className="text-yellow-500 h-8 w-8 mr-3" />;
    return <Info className="text-blue-500 h-8 w-8 mr-3" />;
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 z-50 flex justify-center items-center p-4">
      <div className="bg-gray-800 rounded-lg shadow-2xl w-full max-w-md transform transition-all">
        <div className="p-6">
          <div className="flex items-start">
            {getIcon()}
            <div className="flex-grow">
              <h3 className="text-lg font-bold text-white mb-2">{title}</h3>
              <p className="text-sm text-gray-300 whitespace-pre-wrap">
                {message}
              </p>
            </div>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-white"
            >
              <X size={24} />
            </button>
          </div>
        </div>

        <div className="bg-gray-700/50 px-6 py-4 flex justify-end space-x-4 rounded-b-lg">
          {type === "confirm" && (
            <button
              onClick={onClose}
              className="px-4 py-2 text-sm font-medium text-gray-300 bg-gray-600 hover:bg-gray-500 rounded-md"
            >
              Cancelar
            </button>
          )}
          <button
            onClick={type === "confirm" ? onConfirm : onClose}
            className="px-4 py-2 text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 rounded-md"
          >
            {type === "confirm" ? "Confirmar" : "OK"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
